<template>
  <div class="ml-5 mr-5 mt-5"  id="cloneEvents">
    <v-row>
      <v-col cols="12">
        <p class="text-left mb-0">{{ $t("clone.description") }}</p>
      </v-col>
    </v-row>
    <v-row>
      <v-col cols="12" md="4" class="text-left">
        <v-btn class="btnCE" @click="clone" small color="primary">{{ $t("clone.clone_events") }}</v-btn>
      </v-col>
    </v-row>
    <v-row>
      <v-col cols="12" md="4">
        <v-text-field
          v-model="search"
          append-icon="mdi-magnify"
          :label=" $t('clone.search') "
          hide-details
          dense outlined
        ></v-text-field>
      </v-col>
      <v-col cols="12">
        <v-data-table
          v-model="selected"
          :headers="headersClone"
          :search="search"
          :items="events"
          dense
          item-key="id"
          show-select
          :footer-props="{
            'items-per-page-text': $t('dataTable.rowsPerPageText'),
            'items-per-page-all-text': $t('dataTable.rowsPerPageAllText')
          }"
          :no-data-text="$t('dataTable.noDataText')"
          :headerProps="{
            'sort-by-text': $t('dataTable.sortByText')
          }"
          :no-results-text="$t('dataTable.no_matching_records')"
        >
          <template v-slot:item.displayFlag="{ item }">
            {{ item.displayFlag ? $t("dashboard.menu.eventDetails.yes") : $t("dashboard.menu.eventDetails.no") }}
          </template>
          <template v-slot:item.displayRegistrationFlag="{ item }">
            {{ item.displayRegistrationFlag ? $t("dashboard.menu.eventDetails.yes") : $t("dashboard.menu.eventDetails.no") }}
          </template>
          <template v-slot:[`item.actions`]="{ item }">
            <v-icon
              small
              class="mr-2"
              @click="editItem(item)"
            >
            fas fa-search
            </v-icon>
          </template>
        </v-data-table>
      </v-col>
    </v-row>
    <v-snackbar v-model="snack" :color="color_snack">{{ msg_snack }}</v-snackbar>
  </div>
</template>

<script>
import { apiCalls } from "@/mixins/apiCalls.js";
export default {
  name:"CloneEvents",
  mixins: [apiCalls],
  data(){
    return{
      buttonColor: "#000",
      singleSelect: false,
      selected: [],
      events:[],
      msg_snack: '',
      snack: false,
      color_snack: 'success',
      search: ''
    }
  },
  methods:{
    async clone(){
      this.snack = false;
      if(this.selected.length > 0){
        let events = [];
        this.selected.forEach(x => {
          events.push(x.id);
        });
        let data = {
          ids: events
        }
        const response = await this.api(
          "post",
          "/api/v1/promoter/copyEvent/",
          data
        );
        if(response.success == 1){          
          this.color_snack = "success";
          this.snack = true;
          this.msg_snack = this.$t("clone.msg_success");
        }else{
          this.snack = true;
          this.color_snack = "error";
          this.msg_snack = this.$t("clone.msg_error");
        }
        this.selected = [];
        this.getEvents();
      }else{
        this.snack = true;
        this.color_snack = "warning";
        this.msg_snack = this.$t("clone.msg_warning");
      }
    },
    editItem(event){
      window.location.href = "/admin/eventDetails?eventId="+event.id;
    },
    async getEvents() {
      const response = await this.api(
        "get",
        "/api/v1/users/current/getUserEventList/allE"
      );
      this.events = response.message.map((el) => {
        return {...el, name: this.$escapeHtml.decode(el.name) };
      });
    }
  },
  computed:{
    headersClone(){
      return [
        {
          text: this.$t('clone.event-name'),
          align: 'start',
          sortable: true,
          value: 'name',
        },
        { text: this.$t('clone.registration-open'), value: 'registrationOpen', sortable: true },
        { text: this.$t('clone.registration-close'), value: 'registrationClose', sortable: true  },
        { text: this.$t('clone.event-date'), value: 'eventDate', sortable: true  },
        { text: this.$t('clone.display-event-online'), value: 'displayFlag', sortable: true  },
        { text: this.$t('clone.display-registration-online'), value: 'displayRegistrationFlag', sortable: true  },
        { text: this.$t('clone.actions'), value: 'actions' },
      ]
    }
  },
  created: function() {
    this.buttonColor = process.env.VUE_APP_BUTTON_COLOR;
    this.getEvents();
  }
}
</script>

<style>
.btnCE{
  color:#fff !important;
}
#cloneEvents .v-data-table{
  margin: 0;
}
#cloneEvents .v-data-table > .v-data-table__wrapper > table > tbody > tr > td{
  font-size: 12px;
  padding: 5px;
}
#cloneEvents .v-data-table > .v-data-table__wrapper > table > thead > tr > th{
  padding: 5px;
}
.custFilter {
  background: var(--v-lighten-base) !important;
}
.filter .v-input {
  font-size: 14px;
}
.filter > .v-input__control {
  background-color: #fff;
}
.filter > .v-input__control > .v-input__slot {
  min-height: 32px !important;
}
.filter .v-label {
    top: 7px !important;
}
</style>